








































































































































































































import { AllGeeksSingleSelect } from '@/components';
import { GeekItem } from '@/models';
import { GCoinsHistoryFilters, GCoinGeeksHistory, HistoryTypes } from '@/models/admin-panel';
import { GCoinTransactionType, GCoinTransactionStatus } from '@/models/gcoins';
import { buildGeekName } from '@/utils';
import { collapseMixin } from '@/shared';
import { typedStore, Actions, Getters } from '@/store';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import Multiselect from 'vue-multiselect';

export default mixins(collapseMixin).extend({
  name: 'GCoinsHistoryTab',
  components: {
    AllGeeksSingleSelect,
    Multiselect,
  },
  data() {
    return {
      requestStatusIconMap: {
        rejected: 'log-icon-close',
        pending: 'log-icon-pending',
        ordered: 'log-icon-pending',
        confirmed: 'log-icon-pending',
        accepted: 'log-icon-check',
      },
      filters: {
        immediate: {
          requestedFor: (null as unknown) as string,
          grantedBy: (null as unknown) as string,
          type: (null as unknown) as string,
        } as GCoinsHistoryFilters,
      },
      historyTypes: Object.values(HistoryTypes),
      loader: {
        isHistoryPending: false,
      },
    };
  },
  computed: {
    collapsibleItems(): GCoinGeeksHistory[] {
      return typedStore(this).state.gCoins.historyWithGeek;
    },
    areMoreItemsAvailable(): boolean {
      return this.collapsibleItems.length < typedStore(this).state.gCoins.pagination.totalCount
        && this.collapsibleItems.length > 0;
    },
    filteredGeeks(): GeekItem[] {
      return typedStore(this).getters[Getters.geek.filtered];
    },
  },
  methods: {
    async fetchHistory() {
      this.loader.isHistoryPending = true;
      try {
        await this.$store.dispatch(Actions.gCoins.fetchGCoinsHistory, this.filters.immediate);
      } finally {
        this.loader.isHistoryPending = false;
      }
    },
    async fetchMore() {
      this.loader.isHistoryPending = true;
      try {
        await this.$store.dispatch(Actions.gCoins.fetchMoreGCoinsHistory, this.filters.immediate);
      } finally {
        this.loader.isHistoryPending = false;
      }
    },
    getStatusDescription(historyElement: GCoinGeeksHistory): string {
      if (historyElement.type === GCoinTransactionType.GrantedAutomatically) {
        return this.$t(
          `admin-panel.gcoins.tabs.history.granted-auto`,
          {
            dateTime: (this as any).$options.filters.formattedDateTime(historyElement.status.createdAt),
          },
        ) as string;
      } else if (historyElement.type === GCoinTransactionType.CustomAward
        || historyElement.type === GCoinTransactionType.Withdraw
        || historyElement.type === GCoinTransactionType.GrantedByAdmin
        || historyElement.type === GCoinTransactionType.Exchanged
      ) {
        if (historyElement.status.type === GCoinTransactionStatus.Accepted) {
          return this.$t(
            `admin-panel.gcoins.tabs.history.accepted-by`,
            {
              geek: buildGeekName(historyElement.status.createdBy),
              dateTime: (this as any).$options.filters.formattedDateTime(historyElement.status.createdAt),
              reasonSentence: historyElement.status.reason ? this.$t(
                `admin-panel.gcoins.tabs.history.reason-sentence`,
                { reason: historyElement.status.reason },
              ) : '',
            },
          ) as string;
        } else if (historyElement.status.type === GCoinTransactionStatus.Rejected) {
          return this.$t(
            `admin-panel.gcoins.tabs.history.rejected-by`,
            {
              geek: buildGeekName(historyElement.status.createdBy),
              dateTime: (this as any).$options.filters.formattedDateTime(historyElement.status.createdAt),
              reasonSentence: historyElement.status.reason ? this.$t(
                `admin-panel.gcoins.tabs.history.reason-sentence`,
                { reason: historyElement.status.reason },
              ) : '',
            },
          ) as string;
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
    isTransactionOfIncreaseType(historyElement: GCoinGeeksHistory): boolean {
      return [
        GCoinTransactionType.GrantedAutomatically,
        GCoinTransactionType.GrantedByAdmin,
      ].includes(historyElement.type);
    },
    updateRequestedFor(selectedGeek: GeekItem) {
      this.filters.immediate.requestedFor = selectedGeek ? selectedGeek.id : (null as unknown) as string;
    },
    updateGrantedBy(selectedGeek: GeekItem) {
      this.filters.immediate.grantedBy = selectedGeek ? selectedGeek.id : (null as unknown) as string;
    },
    async preselectRequestedFor() {
      const preselectedGeekId = this.$route.query.requestedForId;

      if (preselectedGeekId) {
        const geek = await this.$store.dispatch(Actions.geek.getGeekBasicInfo, preselectedGeekId) as GeekItem;
        (this.$refs.requestedFor as any)
          .selectedGeek = {...geek, label: geek.firstName + geek.lastName} as GeekItem & { label: string };
        // watcher is invoked - no need to fetch data
        return;
      }

      this.fetchHistory();
    },
    buildGeekName,
  },
  watch: {
    'filters.immediate': {
      handler(this: any) {
        this.fetchHistory();
      },
      deep: true,
    },
  },
});
